import { render } from "./educationHeader.vue?vue&type=template&id=3a88fda8&scoped=true"
import script from "./educationHeader.vue?vue&type=script&lang=js"
export * from "./educationHeader.vue?vue&type=script&lang=js"

import "./educationHeader.vue?vue&type=style&index=0&id=3a88fda8&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a88fda8"]])

export default __exports__